<template>
<div style="width:91px; margin-left:auto; margin-right:auto;">
    <mu-circular-progress :size="90" color="#4caf50"/>
</div>
</template>

<script>
import circularProgress from 'muse-components/circularProgress'

export default {
  name: 'declaration_card',
  data: function () {
    return {
    }
  },
  components: {
    'mu-circular-progress': circularProgress
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Loading.vue?0f523027